import { Form, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import './secciones.scss';

const SeccionTestigos = ({ form }) => {
  return (
    <div>
      <Form form={form} layout="horizontal">
        <div className="container-datos">
          <Form.Item name="nombreTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ nombreTestigo: target.checked });
              }}>
              Nombre(s)
            </Checkbox>
          </Form.Item>
          <Form.Item name="primerApellidoTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ primerApellidoTestigo: target.checked });
              }}>
              Primer apellido
            </Checkbox>
          </Form.Item>
          <Form.Item name="segundoApellidoTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ segundoApellidoTestigo: target.checked });
              }}>
              Segundo apellido
            </Checkbox>
          </Form.Item>
          <Form.Item name="identificacionTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ identificacionTestigo: target.checked });
              }}>
              Identificación
            </Checkbox>
          </Form.Item>
          <Form.Item name="folioTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ folioTestigo: target.checked });
              }}>
              Folio de identificación
            </Checkbox>
          </Form.Item>
          <Form.Item name="expedidaTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ expedidaTestigo: target.checked });
              }}>
              Expedida por
            </Checkbox>
          </Form.Item>
          <Form.Item name="edadTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ edadTestigo: target.checked });
              }}>
              Edad
            </Checkbox>
          </Form.Item>
          <Form.Item name="domicilioTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ domicilioTestigo: target.checked });
              }}>
              Domicilio
            </Checkbox>
          </Form.Item>
          <Form.Item name="institucionTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ institucionTestigo: target.checked });
              }}>
              Institución
            </Checkbox>
          </Form.Item>
          <Form.Item name="cargoTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ cargoTestigo: target.checked });
              }}>
              Cargo
            </Checkbox>
          </Form.Item>
          <Form.Item name="anversoTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ anversoTestigo: target.checked });
              }}>
              Identificación anverso
            </Checkbox>
          </Form.Item>
          <Form.Item name="reversoTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ reversoTestigo: target.checked });
              }}>
              Identificación reverso
            </Checkbox>
          </Form.Item>
          <Form.Item name="firmaTestigo">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ firmaTestigo: target.checked });
              }}>
              Firma
            </Checkbox>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default SeccionTestigos;

SeccionTestigos.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired
};
